import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=6004b9be&scoped=true"
import script from "./Addons.vue?vue&type=script&lang=js"
export * from "./Addons.vue?vue&type=script&lang=js"
import style0 from "./Addons.vue?vue&type=style&index=0&id=6004b9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004b9be",
  null
  
)

export default component.exports